import React, { useState } from "react";
import { useContent } from "../context/ContentContext";
import { processImageFile } from "../utils/imageUpload";

const ENQUIRIES_STORAGE_KEY = "himmelstor_enquiries";

export default function Enquiries() {
  const { content } = useContent();
  const e = content.enquiries || {};
  const [form, setForm] = useState({
    type: "",
    name: "",
    email: "",
    details: "",
    images: [],
  });
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleImageSelect = async (event) => {
    const files = Array.from(event.target.files || []);
    if (!files.length) return;

    setUploading(true);
    setMessage("");
    try {
      const processed = await Promise.all(files.map((f) => processImageFile(f)));
      setForm((prev) => ({ ...prev, images: [...prev.images, ...processed] }));
    } catch (err) {
      setMessage(err.message || "Image upload failed.");
    } finally {
      setUploading(false);
      event.target.value = "";
    }
  };

  const removeImage = (index) => {
    setForm((prev) => ({
      ...prev,
      images: prev.images.filter((_, i) => i !== index),
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const payload = {
      ...form,
      submittedAt: new Date().toISOString(),
    };

    try {
      const existing = JSON.parse(localStorage.getItem(ENQUIRIES_STORAGE_KEY) || "[]");
      localStorage.setItem(ENQUIRIES_STORAGE_KEY, JSON.stringify([payload, ...existing]));
      setMessage("Enquiry submitted successfully with selected images.");
      setForm({ type: "", name: "", email: "", details: "", images: [] });
    } catch (err) {
      setMessage("Failed to save enquiry. Please try again.");
    }
  };

  return (
    <div className="container py-4">
      <h1 className="mb-4 text-success">{e.title || "Enquiries"}</h1>
      <form className="mb-4" onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="type" className="form-label">Type of Enquiry</label>
          <select className="form-select" id="type" required value={form.type} onChange={(evt) => handleChange("type", evt.target.value)}>
            <option value="">Select...</option>
            <option value="agro-tourism">Agro-Tourism Booking</option>
            <option value="consulting">Consulting Enquiry</option>
            <option value="group">Group Visit Request</option>
          </select>
        </div>
        <div className="mb-3">
          <label htmlFor="name" className="form-label">Name</label>
          <input type="text" className="form-control" id="name" required value={form.name} onChange={(evt) => handleChange("name", evt.target.value)} />
        </div>
        <div className="mb-3">
          <label htmlFor="email" className="form-label">Email</label>
          <input type="email" className="form-control" id="email" required value={form.email} onChange={(evt) => handleChange("email", evt.target.value)} />
        </div>
        <div className="mb-3">
          <label htmlFor="details" className="form-label">Details</label>
          <textarea className="form-control" id="details" rows="4" required value={form.details} onChange={(evt) => handleChange("details", evt.target.value)}></textarea>
        </div>
        <div className="mb-3">
          <label htmlFor="images" className="form-label">Choose Images (from your device)</label>
          <input type="file" className="form-control" id="images" accept="image/*" multiple onChange={handleImageSelect} />
          <div className="form-text">You can select one or more photos to attach to this enquiry.</div>
        </div>
        {uploading && <div className="alert alert-info py-2">Processing selected images...</div>}
        {form.images.length > 0 && (
          <div className="mb-3">
            <label className="form-label">Selected images</label>
            <div className="row g-2">
              {form.images.map((src, idx) => (
                <div key={`${idx}-${src.slice(0, 20)}`} className="col-6 col-md-3">
                  <div className="border rounded p-2 h-100">
                    <img src={src} alt={`Selected ${idx + 1}`} className="img-fluid rounded mb-2" />
                    <button type="button" className="btn btn-outline-danger btn-sm w-100" onClick={() => removeImage(idx)}>Remove</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
        {message && (
          <div className={`alert py-2 ${message.startsWith("Enquiry submitted") ? "alert-success" : "alert-danger"}`}>
            {message}
          </div>
        )}
        <button type="submit" className="btn btn-warning">Submit Enquiry</button>
      </form>
      <div className="alert alert-success">{e.responseNote || "We aim to respond to all enquiries within 24 hours."}</div>
    </div>
  );
}
